import {useField} from 'formik';

import {FormControlLabel} from '@mui/material';
import {CheckboxProps} from '@mui/material';

import UICheckbox from './ui/Checkbox';

interface Props {
  name: string;
  label: string;
}

export const FormCheckbox = ({name, label, ...otherProps}: Props & CheckboxProps) => {
  const [field, , helpers] = useField(name);
  return (
    <FormControlLabel
      control={
        <UICheckbox
          {...field}
          {...otherProps}
          checked={field.value}
          onChange={(event: any) => helpers.setValue(event.target.checked)}
        />
      }
      label={label}
    />
  );
};
